import { createAmplitudeEvent } from "@dcc/shared/amplitude";

export const pwaInstalled = createAmplitudeEvent("pwaInstalled");
